/* eslint-disable */

export default {
  HOME: "/",
  BLOG: "/blog",
  FEDERAL: "/federal",
  GET_STARTED: "/get-started",
  GETTING_STARTED: "/getting-started",
  USE_CASES: "/use-cases",
  FLIGHT_PROGRAM: "/flight-program",
  DEVELOPER_HUB: "/developer-hub",
  PROJECTS: "/projects",
  DAG_TOKEN: "/dag-token",
  HYPERGRAPH: "/hypergraph",
  COMMUNITY: "/community",
  LATTICE: "/lattice",
  STARGAZER_WALLET: "/stargazer-wallet",
  DTM: "/dtm",
  DAG_EXPLORER: "/dag-explorer",
  TEAM: "/team",
  TERMS_OF_SERVICE: "/terms-of-service",
  PRIVACY_POLICY: "/privacy-policy",
  GET_DAG: "/buy",
  NEWS: "/blog/categories/news",
  TOKENOMICS: "/Constellation-Network-Token-Economics-v2.pdf",
  CAREERS: "/jobs",
  ENTERPRISE: "/enterprise",
  SNAPSHOT_FEE_CALCULATOR: "/snapshot-fee-calculator",
  DIGITAL_EVIDENCE: "/digital-evidence",
  PACASWAP: "/pacaswap",
  DELEGATED_STAKING: "/delegated-staking"
};
